export class OrderModel{
	public paidAmount: number;
	public paidDate: Date;
	public orderKey: string;
	public orderRefNumber: string;
	public orderRefNumberLong: string;
	public accountKey: string;
	public email: string;
	public orderId: number;
	public orderStatusId: number;
	public orderStatusName: string;
	public orderPayMethod: string;
	public orderPayMethodId: number;
	public currencyId: number;
	public currency: string;
	public clientKey: string;
	public orderDate: Date;
	public orderPaid: boolean = false;
	public orderItems: OrderItemModel[];
	public orderSubtotalInclTax: number;
	public orderSubtotalExclTax: number;
	public orderSubTotalDiscountInclTax: number;
	public orderSubTotalDiscountExclTax: number;
	public orderShippingInclTax: number;
	public orderShippingExclTax: number;
	public paymentMethodAdditionalFeeInclTax: number;
	public paymentMethodAdditionalFeeExclTax: number;
	public orderTax: number;
	public orderDiscount: number;
	public orderTotal: number;
	public refundedAmount: number;
	public itemCount: number = 0;
	public messages: string;
	public manualResponse: ManualPaymentResponseModel;
	public monerisUSResponse: ProviderResponseModel_MonerisUS;
	public monerisCAResponse: ProviderResponseModel_MonerisCA;
	public monerisCheckoutResponse: ProviderResponseModel_MonerisCheckout;
	public chaseUSResponse: ProviderResponseModel_ChaseUS;
	public chaseCAResponse: ProviderResponseModel_ChaseCA;
	public AuthNetCAResponse: ProviderResponseModel_AuthNetCA;
	public AuthNetUSResponse: ProviderResponseModel_AuthNetUS;
	public ElavonResponse: ProviderResponseModel_Elavon;
	public openEdgeResponse: ProviderResponseModel_OpenEdge;
	public globalPaymentsResponse: ProviderResponseModel_GlobalPayments;
	public e_XactResponse: ProviderResponseModel_E_Xact;
	public velocityResponse: ProviderResponseModel_Velocity;
	public cyberSourceResponse: ProviderResponseModel_CyberSource;
	public processingAppKey: string;
	public autoBillingEnabled: boolean;
}

export class OrderItemModel {
	public orderItemKey: string;
	public orderKey: string;
	public entitySourceId: number;
	public itemKey: string;
	public itemDescription: string;
	public quantity: number;
	public currencyTypeId: number;
	public unitPriceInclTax: number;
	public unitPriceExclTax: number;
	public priceInclTax: number;
	public priceExclTax: number;
	public discountAmountInclTax: number;
	public discountAmountExclTax: number;
	public itemDate: Date;
	public itemNumber: string;
	public itemCode: string;
	public itemDetail: string;
	public paidAmount: number;
	public amountDue: number;
	public statusId: number;
	public statusName: string;
	public autoBillingModel: AutoBillingModel;
}

export class InvoiceModel{
	public invoiceNumber: string;
	public invoiceNumberLong: string;
	public invoiceId: number;
	public invoiceItems: InvoiceItemModel[];
	public amountDue: number = 0;
	public itemCount: number = 0;
	public invoiceTxnStatus: number;
	public invoiceDate: Date;
	public invoicePaid: boolean = false;
	public invoiceActivities: Activity[] = [];
	public paymentAccepted: boolean = false;
	public paidAmount: number;
	public paidDate: Date;
	public paidConfirmation: string ;
	public paidSource: string;
	public paidMethodId: number;
	public email: string;
	public orderKey: string;
	public manualResponse: ManualPaymentResponseModel;
	public monerisUSResponse: ProviderResponseModel_MonerisUS;
	public monerisCAResponse: ProviderResponseModel_MonerisCA;
	public monerisCheckoutResponse: ProviderResponseModel_MonerisCheckout;
	public chaseUSResponse: ProviderResponseModel_ChaseUS;
	public chaseCAResponse: ProviderResponseModel_ChaseCA;
	public authNetCAResponse: ProviderResponseModel_AuthNetCA;
	public authNetUSResponse: ProviderResponseModel_AuthNetUS;
	public elavonResponse: ProviderResponseModel_Elavon;
	public openEdgeResponse: ProviderResponseModel_OpenEdge;
	public globalPaymentsResponse: ProviderResponseModel_GlobalPayments;
	public e_XactResponse: ProviderResponseModel_E_Xact;
	public velocityResponse: ProviderResponseModel_Velocity;
	public cyberSourceResponse: ProviderResponseModel_CyberSource;
	public processingAppKey: string;
}

export class InvoiceItemModel {
	public itemId: number;
	public itemKey: string;
	public itemName: string;
	public description: string;
	public units: number;
	public unitPrice: number;
	public net: number;
	public itemType: string;
	public itemTypeId: number;
}

export class Activity {
	public activityDate: Date;
	public activityType: string;
	public activityUser: string;
	public activityNotes: string;
}

export class ManualPaymentResponseModel {
	public amountDue: number;
	public paidAmount: number;
	public paidDate: Date;
	public paidConfirmation: string;
	public paidSource: number;
	public isFinalPayment: boolean;
	public paidMethodId: number;
}

export class ProviderResponseModel_MonerisUS {
	public order_no: string;
	public ref_num: string;
	public response_code: string;
	public auth_code: string;
	public txn_time: string;
	public txn_date: string;
	public txn_type: string;
	public message: string;
	public amount: number;
	public cardholder: string;
	public card_num: string;
	public card_type: string;
	public exp_month: string;
	public exp_year: string;
	public txn_num: string;
	public crypt_type: string;
	public result: string;
	public verify_key: string;
	public avs_result: string;
	public cvd_result: string;
	public recur_result: string;
	public rvarprocName: string;
	public rvarclientKey: string;
	public rvarinvoiceId: string;
	public rvarinvoiceNumber: string
}
export class ProviderResponseModel_MonerisCA {
	public bank_approval_code: string;
	public bank_transaction_id: string;
	public card: string;
	public cardholder: string;
	public charge_total: number;
	public date_stamp: string;
	public expiry_date: string;
	public f4l4: string;
	public iso_code: string;
	public message: string;
	public response_code: string;
	public response_order_id: string;
	public result: string;
	public time_stamp: string;
	public trans_name: string;
	public transactionKey: string;
	public cust_id: string;
	public order_id: string;
	public id1: number;
	public email: string;
	public rvarinvoiceId: string;
	public rvarinvoiceNumber: string;
	public rvarclientKey: string;
	public recur_result: string;
}
export class ProviderResponseModel_MonerisCheckout {
	public response: MonerisCheckoutResponseModel;
	public mcoClientKey: string;
	public mcoInvoiceId: string;
	public mcoInvoiceNumber: string;
	public charge_total: number;
	public cancelTxn: boolean;
	public appKey: string;

	constructor() {
		this.response = new MonerisCheckoutResponseModel();
	}
}
export class MonerisCheckoutResponseModel {
	public success: string;
	public ticket: string;
	public result: string;
	public is_applepay: string;
	public is_expiry: string;
	public email_receipt: string;
	public email_receipt_address: string;
	public header_background_colour: string;
	public header_text_colour: string;
	public merchant_name: string;
	public order_confirmation: string;
	public data: MonerisCheckoutResponseDataModel;
	public error_type: string;
	public error: MonerisCheckoutResponseErrorModel[];
}
export class MonerisCheckoutResponseDataModel {
	public card_type: string;
	public is_valid: string;
}
export class MonerisCheckoutResponseErrorModel {
	public field: string;
	public message: string;
}
export class ProviderResponseModel_ChaseUS {
	public code: string;
	public message: string;
	public uID: string;
	public action: string;
	public procName: string;
	public cancel: string;
	public order_key: string;
	public order_desc: string;
	public appKey: string;
}
export class ProviderResponseModel_ChaseCA {

}
export class ProviderResponseModel_AuthNetUS {
	public ck: string;
	public ok: string;
	public on: string;
	public completedTxn: boolean;
	public cancelTxn: boolean;
	public procname: string;
	public amount: number;
	public txnDate: Date;
}
export class ProviderResponseModel_AuthNetCA {

}

export class ProviderResponseModel_Elavon {

	public ssl_account_balance: number;
	public ssl_add_token_response: string;
	public ssl_amount: number;
	public ssl_approval_code: string;
	public ssl_avs_response: string;
	public ssl_balance_due: number;
	public ssl_base_amount: number;
	public ssl_card_number: string;
	public ssl_card_short_description: string;
	public ssl_card_type: string;
	public ssl_cardholder_amount: number;
	public ssl_cardholder_base_amount: number;
	public ssl_cardholder_currency: string;
	public ssl_cardholder_tip_amount: number;
	public ssl_conversion_rate: number;
	public ssl_cvv2_response: string;
	public ssl_eci_ind: string;
	public ssl_invoice_number: string;
	public ssl_promo_code: string;
	public ssl_promo_code_description: string;
	public ssl_promo_code_issue_points: string;
	public ssl_promo_code_name: string;
	public ssl_promo_list: string;
	public ssl_promo_product: string;
	public ssl_requested_amount: number;
	public ssl_result: number;
	public ssl_result_message: string;
	public ssl_server: string;
	public ssl_shift: string;
	public ssl_tip_amount: number;
	public ssl_token: string;
	public ssl_token_response: string;
	public ssl_transaction_currency: string;
	public ssl_txn_id: string;
	public ssl_txn_time: string;
	public ssl_description: string;
	public ssl_reference_number: string;
	public ven_client_key: string;
	public ven_order_key: string;
}

export class ProviderResponseModel_OpenEdge{
	public appKey: string;
	public order_id: string;
	public response_code: string;
	public secondary_response_code: string;
	public response_code_text: string;
}

export class ProviderResponseModel_GlobalPayments {
	public RESULT: string;
	public AUTHCODE: string;
	public MESSAGE: string;
	public PASREF: string;
	public AVSPOSTCODERESULT: string;
	public AVSADDRESSRESULT: string;
	public CVNRESULT: string;
	public ACCOUNT: string;
	public MERCHANT_ID: string;
	public ORDER_ID: string;
	public TIMESTAMP: string;
	public AMOUNT: string;
	public BATCHID: string;
	public CARD_PAYMENT_BUTTON: string;
	public MERCHANT_RESPONSE_URL: string;
	public HPP_LANG: string;
	public BILLING_CODE: string;
	public BILLING_CO: string;
	public SHIPPING_CODE: string;
	public SHIPPING_CO: string;
	public COMMENT1: string;
	public COMMENT2: string;
	public ECI: string;
	public AUTHENTICATION_VALUE: string;
	public DS_TRANS_ID: string;
	public MESSAGE_VERSION: string;
	public SRD: string;
	public SHA1HASH: string;
	public CUST_NUM: string;
	public VAR_REF: string;
	public CLIENT_KEY: string;
	public ORDER_KEY: string;
	public appKey: string;
}

export class ProviderResponseModel_E_Xact {
	public order_key: string;
	public AVS: string;
	public Authorization_Num: string;
	public Bank_Message: string;
	public Bank_Resp_Code: string;
	public Bank_Resp_Code_2: string;
	public CAVV_Algorithm: string;
	public CAVV_Response: string;
	public CVD_Presence_Ind: string;
	public CVV2: string;
	public CardHoldersName: string;
	public Card_Number: string;
	public Client_Email: string;
	public Client_IP: string;
	public Customer_Ref: string;
	public DollarAmount: string;
	public EXact_Message: string;
	public EXact_Resp_Code: string;
	public Ecommerce_Flag: string;
	public Expiry_Date: string;
	public Language: string;
	public Reference_3: string;
	public Reference_No: string;
	public Retrieval_Ref_No: string;
	public Secure_AuthRequired: string;
	public Secure_AuthResult: string;
	public SequenceNo: string;
	public SurchargeAmount: string;
	public Tax1Amount: string;
	public Tax1Number: string;
	public Tax2Amount: string;
	public Tax2Number: string;
	public TransactionCardType: string;
	public Transaction_Approved: string;
	public Transaction_Error: string;
	public Transaction_Tag: string;
	public Transaction_Type: string;
	public XID: string;
	public ZipCode: string;
	public exact_issconf: string;
	public exact_issname: string;
	public exact_wsp_version: string;
	public x_address: string;
	public x_amount: string;
	public x_auth_code: string;
	public x_avs_code: string;
	public x_cavv_response: string;
	public x_city: string;
	public x_company: string;
	public x_country: string;
	public x_cust_id: string;
	public x_cvv2_resp_code: string;
	public x_description: string;
	public x_duty: string;
	public x_email: string;
	public x_fax: string;
	public x_first_name: string;
	public x_freight: string;
	public x_invoice_num: string;
	public x_last_name: string;
	public x_method: string;
	public x_phone: string;
	public x_po_num: string;
	public x_reference_3: string;
	public x_response_code: string;
	public x_response_reason_code: string;
	public x_response_reason_text: string;
	public x_response_subcode: string;
	public x_ship_to_address: string;
	public x_ship_to_city: string;
	public x_ship_to_company: string;
	public x_ship_to_country: string;
	public x_ship_to_first_name: string;
	public x_ship_to_last_name: string;
	public x_ship_to_state: string;
	public x_ship_to_zip: string;
	public x_state: string;
	public x_tax: string;
	public x_tax_exempt: string;
	public x_trans_id: string;
	public x_type: string;
	public x_zip: string;
	public WalletType: string;
	public x_SHA1_Hash: string;
	public appKey: string;
}

export class ProviderResponseModel_Velocity {
	public guid: string;
	public remittance_id: string;
	public security_id: string;
	public total: number;
	public transaction_status: string;
}

export class ProviderAuthResponseModel_Heartland {
	public MultiCaptureSequence: number;
	public MultiCapturePaymentCount: number;
	public MultiCapture: boolean;
	public HostResponseDate: Date;
	public EmvIssuerResponse: string;
	public CvnResponseCode: string;
	public CommercialIndicator: string;
	public OriginalTransactionTime: string;
	public SystemTraceAuditNumber: string;
	public MessageTypeIndicator: string;
	public ConvenienceFee: number;
	public CvnResponseMessage: string;
	public OrderId: string;
	public PointsBalanceAmount: number;
	public ClientTransactionId: string;
	public TransactionToken: string;
	public TokenUsageMode: number; //PaymentMethodUsageMode
	public Token: string;
	public ProcessingCode: string;
	public TransactionId: string;
	public PaymentMethodType: number; //PaymentMethodType
	public TimeResponseFromHeartland: string;
	public Timestamp: string;
	public SchemeId: string;
	public ResponseValues: any[];
	public ResponseMessage: string;
	public ResponseCode: string;
	public ReferenceNumber: string;
	public RecurringDataCode: string;
	public TransactionDescriptor: string;
	public CavvResponseCode: string;
	public CardExpYear: number;
	public CardholderName: string;
	public AutoSettleFlag: string;
	public AuthorizationCode: string;
	public AvailableBalance: number;
	public AvsResponseCode: string;
	public AvsResponseMessage: string;
	public AvsAddressResponse: string;
	public BalanceAmount: number;
	public AuthorizedAmount: number;
	public CardBrandTransactionId: string;
	public CardExpMonth: number;
	public CardNumber: string;
	public FingerPrintIndicator: string;
	public FingerPrint: string;
	public CardLast4: string;
	public CardType: string;
}

export class ProviderResponseModel_CyberSource {
	public appKey: string;
	public orderKey: string;
	public clientKey: string;
	public orderNumber: string;
	public transientToken: string;
	public orderAmount: number;
	public nameOnCard: string;
	public firstName: string;
	public lastName: string;
	public address1: string;
	public address2: string;
	public locality: string;
	public region: string;
	public postalCode: string;
	public country: string;
	public phoneNumber: string;
	public emailAddress: string;
}

export class AutoBillingModel {
	public autoBillingAvailable: boolean;
	public autoBillingRequested: boolean;
	public periodType: number; 
	public period: number;
	public immediateCharge: boolean;
	public firstAutoChargeDate: Date;
	public chargeAmount: number;
	public maxPeriods: number;
}